export default __webpack_public_path__ + "static/media/eye-close.f6292db8.svg";